import React from 'react';
import { Mic, CheckCheck, Bot } from 'lucide-react';

// A WhatsApp-style sample conversation for the AI Assistant section. The real chat lives inside
// WhatsApp, so there is nothing to screenshot; this is built in JSX and labelled as a sample.
// Names, prices and times are invented.

const TURNS = [
  { from: 'customer', text: 'Hi, how much is a full service for a 2021 Camry?', time: '02:14' },
  { from: 'ai', text: 'A full service for the Camry starts at AED 420 and takes about 3 hours. The earliest open slots are tomorrow at 10:00 or 14:30.', time: '02:14' },
  { from: 'customer', voice: '0:07', time: '02:15' },
  { from: 'ai', text: 'Got it, 10:00 tomorrow. Shall I book that for you?', time: '02:15' },
  { from: 'customer', text: 'Yes please', time: '02:15' },
  { from: 'ai', text: 'Booked for tomorrow 10:00. A reminder will reach you in the morning.', time: '02:16' },
];

export default function AiChatMock({ d, isDark, compact = false, caption = 'Sample conversation, 2:14 am' }) {
  const turns = compact ? TURNS.slice(0, 4) : TURNS;
  const bg = isDark ? '#0B141A' : '#ECE5DD';
  const customerBubble = isDark ? '#005C4B' : '#DCF8C6';
  const aiBubble = isDark ? '#202C33' : '#FFFFFF';
  const ink = isDark ? '#E9EDEF' : '#111B21';

  return (
    <figure style={{ margin: 0 }}>
      <div style={{ maxWidth: compact ? 'none' : 380, margin: '0 auto', borderRadius: 22, overflow: 'hidden', border: `1px solid ${d.borderMd}`, boxShadow: d.sh8, background: bg }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: isDark ? '#202C33' : '#075E54', color: '#fff' }}>
          <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Bot size={18} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.2 }}>Your workshop</div>
            <div style={{ fontSize: 11, opacity: 0.8 }}>AI Assistant · replies instantly</div>
          </div>
        </div>

        <div style={{ padding: '14px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          {turns.map((t, i) => {
            const mine = t.from === 'customer';
            return (
              <div key={i} style={{ alignSelf: mine ? 'flex-end' : 'flex-start', maxWidth: '82%', background: mine ? customerBubble : aiBubble, color: ink, borderRadius: 10, padding: '7px 10px 5px', boxShadow: '0 1px 1px rgba(0,0,0,0.13)', fontSize: compact ? 11.5 : 13, lineHeight: 1.4 }}>
                {t.voice ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 150 }}>
                    <Mic size={15} />
                    <div style={{ flex: 1, height: 3, borderRadius: 2, background: isDark ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.25)' }} />
                    <span style={{ fontSize: 11 }}>{t.voice}</span>
                  </div>
                ) : t.text}
                <div style={{ textAlign: 'right', fontSize: 10, opacity: 0.6, marginTop: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3 }}>
                  {t.time}{mine && <CheckCheck size={12} color="#53BDEB" />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {!compact && <figcaption style={{ marginTop: 10, textAlign: 'center', fontSize: 12, color: d.textMuted }}>{caption}</figcaption>}
    </figure>
  );
}
